import React, { useContext, useEffect, useState, useRef, useMemo, useCallback } from 'react';
import { getRequest, postRequest, deleteRequest, tabulatorGet } from '../../api/ApiController';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css'
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import { AddIcon, EditIcon, DeleteIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon,EditRowIcon,SeenIcon,UnseenIcon} from "../svg/svgIcons";
import UtilContext from '../../components/UtilContext';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../utils/tabulatorScroll';
import { cleanSorters, parseSorters, parseMaskFilters, safeParse, extractSafePaginationParams, createDedupedAjaxRequest, rowPassesChecklistHeaderFilters, refreshProgressiveFromStart } from '../../utils/tabulatorProgressiveLoading';
import { getPusherChannel } from '../../utils/pusherChannel';
import { primeMultiSelectHeaderFilter } from '../../utils/primeMultiSelectHeaderFilter';
import { resetTabulatorMask } from '../../utils/tabulatorResetMask';
import { Checkbox } from 'primereact/checkbox';
import { PanelMenu } from 'primereact/panelmenu';
import { Avatar } from 'primereact/avatar';
import AuthContext from '../../components/AuthContext';
import { DateTime } from "luxon";
import { getTimezone } from '../../utils/moduleSettings';
import {ExecutionDeadlineFormatter,executionDeadlineFilter} from "./ChecklistExecutionDeadline";
import { LocaleContext } from '../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../utils/printChrome';
import { canCreateChecklistRecord } from '../../utils/checklistRecordCreateHttp';
import { applyTabulatorRuntimeI18n } from '../../utils/tabulatorRuntimeI18n';
import { toLocalDateString } from '../../utils/previewDateRange';
const CHECKLIST_RECORD_MY_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'template.name': 'Common.Name',
  'is_unread': 'Common.Read',
  'name': 'Common.Description',
  'custom_department': 'Common.Department',
  'created_at': 'Common.Column.CreatedAt',
  'user_update_at': 'Checklist.Column.CompletionDate',
  'execution_deadline': 'Checklist.Column.CompletionDeadline',
  'updated_at': 'Common.Column.UpdatedAt',
  'status': 'Common.Status',
  'process_status': 'Checklist.Column.ProcessStatus',
  'manager_name': 'Checklist.Column.ResponseDate',
  'manager_status': 'Checklist.Column.ResponseStatus',
  'checklist_status': 'Checklist.Column.ChecklistStatus',
  'template.machine.name': 'Common.Machine',
  'id': 'MachineTypeList.Column.Id',
  'deadline': 'ChecklistRecordList.Column.StatementDeadline',
  'manager_response': 'MaintenanceCheckStateList.Column.Statement',
});


function checklistPreviewFilter(data, filterParams) {
  const { time_period, date, preview } = filterParams;
  const inDateRange = () => {
    if (!date) return true;
    const created = data?.created_at;
    if (!created) return false;
    if (time_period === 'Za deň') return new Date(created).toDateString() === new Date(date).toDateString();
    if (time_period === 'Za mesiac') return new Date(created).getFullYear() === new Date(date).getFullYear() && new Date(created).getMonth() === new Date(date).getMonth();
    if (time_period === 'Za rok') return new Date(created).getFullYear() === new Date(date).getFullYear();
    if (time_period === 'Vlastné' && Array.isArray(date) && date.length >= 2) {
      const end = new Date(date[1]);
      end.setDate(end.getDate() + 1);
      return new Date(created).valueOf() >= new Date(date[0]).valueOf() && new Date(created).valueOf() <= end.valueOf();
    }
    return true;
  };
  if (!inDateRange()) return false;
  if (preview === 'ok') return (data?.status ?? '') === 'OK' && (data?.process_status ?? '') !== 'Rozpracovaný';
  if (preview === 'nok') return (data?.status ?? '') === 'NOK' && (data?.process_status ?? '') === 'Vytvorený';
  if (preview === 'rozpracovane') return (data?.process_status ?? '') === 'Rozpracovaný';
  if (preview === 'nevytvoreny') {
    const ps = (data?.process_status ?? '').trim();
    return ps !== 'Vytvorený' && ps !== 'Rozpracovaný';
  }
  return true;
}

function getMyListDateRange(timePeriod, date) {
  if (!date) return { from: null, to: null };
  if (timePeriod === 'Za deň') {
    const s = toLocalDateString(new Date(date));
    return { from: s, to: s };
  }
  if (timePeriod === 'Za mesiac') {
    const d = new Date(date);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const lastDay = new Date(y, d.getMonth() + 1, 0).getDate();
    return { from: `${y}-${m}-01`, to: `${y}-${m}-${String(lastDay).padStart(2, '0')}` };
  }
  if (timePeriod === 'Za rok') {
    const y = new Date(date).getFullYear();
    return { from: `${y}-01-01`, to: `${y}-12-31` };
  }
  if (timePeriod === 'Vlastné' && Array.isArray(date) && date.length >= 2) {
    return { from: toLocalDateString(new Date(date[0])), to: toLocalDateString(new Date(date[1])) };
  }
  return { from: null, to: null };
}

export default function ChecklistRecordMyList({ preview = null, timePeriod = null, date = null }) {

  const [state,dispatch] = useContext(DatabaseContext);
  const {user} = useContext(AuthContext);
  const canCreate = canCreateChecklistRecord(user);
  const { t, locale } = useContext(LocaleContext);
  const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,getUserInitials,getUserColor,formatID,getDateFormat,formatDate, openChosenNotificationPreferences} = useContext(UtilContext);
  const dateFmt = getDateFormat?.() ?? "dd.MM.yyyy";
  const dateTimeFmt = `${dateFmt} HH:mm`;
  const timezone = getTimezone(state?.module_settings || []);

  const pageSizePc = useMemo(() => {
    const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
    const n = parseInt(v, 10);
    return (Number.isFinite(n) && n > 0) ? n : 50;
  }, [state.module_settings]);

  const [editIcon,setEditIcon] = useState(true);
  const [deleteIcon,setDeleteIcon] = useState(true);
  const [favoriteIcon,setFavoriteIcon] = useState(false);
  const [copyIcon,setCopyIcon] = useState(true);

  const [markUnmark, setMarkUnmarked] = useState(true);

  const [visibleSearch,setVisibleSearch] = useState(false);
  const [searchValue,setSearchValue] = useState('');

    const [editFormDepartment, setEditFormDepartment] = useState([]);

  const DEFAULT_COLUMNS_VISIBLE_MY = { "template.name": true, "template.machine.name": true, id: true, is_unread: true, name: true, custom_department: true, created_at: true, user_update_at: true, execution_deadline: true, updated_at: true, status: true, process_status: true, manager_name: true, deadline: true, manager_response: true, manager_status: true, checklist_status: true };
  const [columnsVisible, setColumnsVisible] = useState({ ...DEFAULT_COLUMNS_VISIBLE_MY });
  const [maskVisible, setMaskVisible] = useState(false);
const [substituteDialogVisible, setSubstituteDialogVisible] = useState(false);
  const [substituteOptions, setSubstituteOptions] = useState([]);

    const ref = useRef(null);
    const elementRef = useRef(null);
    const overlayRef = useRef(null);
    const previewRef = useRef(preview);
    const timePeriodRef = useRef(timePeriod);
    const dateRef = useRef(date);
    useEffect(() => {
      previewRef.current = preview;
      timePeriodRef.current = timePeriod;
      dateRef.current = date;
    }, [preview, timePeriod, date]);

    const tableBuiltRef = useRef(false);
    const isRestoringRef = useRef(false);
    const userInteractedRef = useRef(false);
    const useMaskDefaultsRef = useRef(true);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const maskAppliedRef = useRef(false);
    const lastMaskSigRef = useRef("");
    const maskToApplyRef = useRef(null);
    const [tableReady, setTableReady] = useState(false);
    const pagingRef = useRef({ current: 1, last: 1 });
    const loadingRef = useRef(false);
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const needsRedrawRef = useRef(false);
    const pendingRowIdsRef = useRef(new Set());
    const rafRedrawRef = useRef(null);
    const tableContainerRef = useRef(null);
    const currentFilterRef = useRef({ preview: null, timePeriod: null, date: null });

    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingData')), [getTable]);

    const isTableVisible = useCallback(() => {
      const table = getTable();
      if (!table) return false;
      const el = table.getElement?.() ?? table.element ?? table.rowManager?.element?.parentElement;
      return !!(el && el.offsetParent != null && el.clientHeight > 0);
    }, [getTable]);

    const scheduleRedraw = useCallback(() => {
      if (rafRedrawRef.current != null) return;
      rafRedrawRef.current = requestAnimationFrame(() => {
        const table = getTable();
        rafRedrawRef.current = null;
        if (!table) return;
        const ids = Array.from(pendingRowIdsRef.current);
        pendingRowIdsRef.current.clear();
        needsRedrawRef.current = false;
        const filterParams = currentFilterRef.current;
        const headerFilters = table.getHeaderFilters?.() ?? [];
        ids.forEach((id) => {
          const row = table.getRow?.(id);
          if (!row) return;
          const data = row.getData?.();
          if (!data) return;
          if (!checklistPreviewFilter(data, filterParams)) {
            row.delete?.();
            return;
          }
          if (!rowPassesChecklistHeaderFilters(data, headerFilters)) {
            row.delete?.();
            return;
          }
          row.reformat?.();
        });
      });
    }, [getTable]);

    useEffect(() => {
      currentFilterRef.current = {
        preview: previewRef.current,
        timePeriod: timePeriodRef.current,
        date: dateRef.current
      };
    }, [preview, timePeriod, date]);

    const captureHScroll = () => {
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      if (!holder) return;
      savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    };

    const restoreHScroll = () => {
      if (!savedHScrollRef.current.pending) return;
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      const header = table.columnManager?.contentsElement;
      if (!holder) return;
      const left = savedHScrollRef.current.left;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          holder.scrollLeft = left;
          if (header) header.scrollLeft = left;
          savedHScrollRef.current.pending = false;
        });
      });
    };

    function matchAny(data, filterParams) {
      var match = false;
      const regex = RegExp(filterParams.value, 'i');
      for (var key in data) {
          if (regex.test(data[key]) === true) {
              match = true;
          }
      }
      return match;
    }

    function searchTable(){
      const t = getTable();
      if (t) t.setFilter(matchAny, { value: searchValue});
      if (searchValue === " ") {
        getTable()?.clearFilter?.();
      }
      setVisibleSearch(false);
    }

    const accept = () => {
        const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
        setDialogText(t('Common.Deleting'));
        setVisible(true);

        const deletePromises = rows_to_delete.map((element) =>
            deleteRequest(`/api/checklist_records/${element.id}`)
        );

        Promise.allSettled(deletePromises).then((results) => {
            setVisible(false);
            const successCount = results.filter(r => r.status === "fulfilled").length;
            const failCount = results.filter(r => r.status === "rejected").length;
            if (successCount > 0 && failCount === 0) {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), detail: t('Common.Toast.RecordsDeletedDetail').replace('{{count}}', String(successCount)), life: 3000 });
            } else if (successCount > 0 && failCount > 0) {
                toast?.current?.show({ severity: 'warn', summary: t('Common.Toast.PartialDeletedSummary'), detail: t('Common.Toast.PartialDeletedDetail').replace('{{success}}', String(successCount)).replace('{{fail}}', String(failCount)), life: 3000 });
            } else {
                toast?.current?.show({ severity: 'error', summary: t('Common.Error'), detail: t('Common.Toast.NoneDeletedDetail'), life: 3000 });
            }

            if (successCount > 0) {
                const table = getTable();
                rows_to_delete.forEach(r => {
                    const row = table?.getRows?.().find(x => x.getData().id === r.id);
                    if (row) row.delete();
                });
            } else {
                refreshFromStart();
            }
            return Promise.resolve();
        });
    };


    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.RequestCancelled'), life: 3000 });
    }

    const confirm = () => {
        confirmDialog({
            message: t('Common.ConfirmDeleteRecords'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.Yes'),
            rejectLabel: t('Common.No'),
            accept,
            reject
        });
    };

const rowClick = (e, row) => {
    console.log(e, row);
};

const onSelectRow = (data, rows) => {
  setEditIcon(true);
  setCopyIcon(true);
  setDeleteIcon(true);
  const selected = getTable()?.getSelectedData?.() ?? [];
  if(selected.length === 1){
      if(user.permissions?.includes("add checklists"))setEditIcon(false);
      if(user.permissions?.includes("delete checklists"))setDeleteIcon(false);
      if(user.permissions?.includes("add checklists"))setCopyIcon(false);
      setEditFormDepartment(data);  
  }
  else if(selected.length > 1){
    if(user.permissions?.includes("delete checklists"))setDeleteIcon(false);
  }
};

function onEditRow(checklist_record){
  const table = getTable();
  const filters = (table?.getHeaderFilters?.() || []).map(f => ({ field: f.field, value: f.value }));
  const sorters = cleanSorters(table?.getSorters?.() || []);
  const { from, to } = getMyListDateRange(timePeriodRef.current, dateRef.current);
  const navigationContext = { filters, sorters, preview: previewRef.current, preview_time_from: from || undefined, preview_time_to: to || undefined };
  dispatch({type: 'create_new_tab', name: t('Checklist.RecordTab'), translationKey: 'Checklist.RecordTab', legacyLabel: t('Checklist.RecordTab'),page:'ChecklistRecordMyDetail',props:{checklist_record,recordId: checklist_record?.id,type:'edit',navigationContext},mask:'chck006'})
};

function EditRowFormatter(props) {
  const rowData = props.cell.getRow().getData();
  return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
}

function removeDiacritics(str) {
    return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function genericFilter(headerValue, rowValue) {
  if (!headerValue) return true;
  if (!rowValue) return false;
  return removeDiacritics(rowValue.toString().toLowerCase()).includes(removeDiacritics(headerValue.toString().toLowerCase()));
}

const extractDepartmentsFromRecipients = (recipients) => {
      const departmentMap = new Map();

      recipients.forEach((user) => {
          const dept = user?.employee?.department;
          if (dept && !departmentMap.has(dept.id)) {
            departmentMap.set(dept.id, {
                id: dept.id,
                name: dept.name,
                searchLabel: removeDiacritics(dept.name).toLowerCase(),
            });
          }
          else if(user?.employee?.department_id){
            let db_dept = state.departments.find(department => department.id == user?.employee?.department_id);
            departmentMap.set(db_dept.id, {
                id: db_dept.id,
                name: db_dept.name,
                searchLabel: removeDiacritics(db_dept.name).toLowerCase(),
            });
          }
      });

      return Array.from(departmentMap.values());
  };

function DepartmentFormatter(props) {
    const rowData = props.cell.getRow().getData();
    return extractDepartmentsFromRecipients([rowData?.user]).map(departmnent => departmnent?.name).join(', ');
}

  function departmentFilter(headerValue, rowValue, rowData, filterParams) {
    if (!headerValue) return true;

    const search = removeDiacritics(headerValue).toLowerCase();
    const deptId = rowData?.user?.employee?.department_id;
    if (!deptId) return false;

    const found = state?.departments.find(d => d?.id == deptId);
    return found ? removeDiacritics(found.name).toLowerCase().includes(search) : false;
  }

function UserFormatter(props) {
      const rowData = props.cell.getRow().getData();
      if(rowData?.process_status== 'Nevytvorený'){
        return <div className='flex items-center justify-start w-full h-full'>
          <Avatar className='p-overlay-badge' title="System" icon="pi pi-database" shape="circle" style={{ backgroundColor: 'grey', color: '#ffffff',marginRight: '5px'}}/>
          <div>{formatDate(rowData.created_at, true)}</div>
      </div>;
      }
      const userName = rowData?.user?.employee?.name || rowData?.user?.username;
      const userAvatar = (
        <Avatar
          title={userName}
          label={getUserInitials(userName)}
          shape="circle"
          style={{ backgroundColor: getUserColor(rowData?.user?.username), color: '#ffffff', marginRight: '5px' }}
        />
      );
      const isSubstitute = rowData?.is_substitute;

      return <div className='flex items-center justify-start w-full h-full'>
          {rowData?.user && (
            <div>
              {isSubstitute ? (
                <span style={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}>{userAvatar}<span className="p-badge p-badge-info" style={{ position: 'absolute', top: '-2px', right: '-2px', fontSize: '0.75rem', minWidth: '14px', height: '14px', lineHeight: '14px', padding: '0 3px' }}>Z</span></span>
              ) : userAvatar}
            </div>
          )}
          <div>{formatDate(rowData.created_at, true)}</div>
      </div>;
  }

  function userFilter(headerValue, rowValue, rowData) {
    if (!headerValue) return true;
    const search = removeDiacritics(headerValue).toLowerCase();

    const isSystem = rowData?.process_status === "Nevytvorený";
    const who = isSystem
      ? "System"
      : (rowData?.user?.employee?.name || rowData?.user?.username || "");

    const when = rowData?.created_at
      ? formatDate(rowData.created_at, true)
      : "";

    const combined = `${who} ${when}`;
    return removeDiacritics(combined).toLowerCase().includes(search);
  }


  function ManagerFormatter(props) {
      const rowData = props.cell.getRow().getData();
      if(rowData?.status === "NOK" && (rowData?.checklist_status || "").toLowerCase() !== "uzavretý")return "";
      const isBotCase = rowData?.status === "OK" && (rowData?.checklist_status || "").toLowerCase() === "uzavretý";
      const timeToShow = isBotCase ? rowData?.user_update_at : rowData?.manager_update_at;
      return (
        <div className="flex items-center justify-start w-full h-full">
          {isBotCase ? (
            <div className="mr-2">
              <Avatar className='p-overlay-badge' title="System" icon="pi pi-database" shape="circle" style={{ backgroundColor: 'grey', color: '#ffffff',marginRight: '5px'}}/>
            </div>
          ) : (
            (rowData?.manager || rowData?.template?.manager) && (
              <div className='mr-2'>
                <Avatar
                  title={rowData?.manager?.employee?.name || rowData?.manager?.username || rowData?.template?.manager?.employee?.name || rowData?.template?.manager?.username}
                  label={getUserInitials(rowData?.manager?.employee?.name || rowData?.manager?.username || rowData?.template?.manager?.employee?.name || rowData?.template?.manager?.username)}
                  shape="circle"
                  style={{
                    backgroundColor: getUserColor(rowData?.manager?.username || rowData?.template?.manager?.username),
                    color: "#ffffff",
                    marginRight: "5px",
                  }}
                />
              </div>
            )
          )}
  
          {timeToShow && (
            <div>
              {/* ak máš SQL string */}
              {formatDate(timeToShow, true)}
            </div>
          )}
        </div>
      );
    }
  
    function managerHeaderFilter(headerValue, rowValue, rowData) {
      if (!headerValue) return true;
      const search = removeDiacritics(headerValue).toLowerCase();
      if(rowData?.status === "NOK" && (rowData?.checklist_status || "").toLowerCase() !== "uzavretý")return false;
  
      const isBotCase =
        rowData?.status === "OK" &&
        (rowData?.checklist_status || "").toLowerCase() === "uzavretý";
  
      const who = isBotCase
        ? "System"
        : (rowData?.manager?.employee?.name ||
          rowData?.manager?.username ||
          rowData?.template?.manager?.employee?.name ||
          rowData?.template?.manager?.username ||
          "");
      const timeToShow = isBotCase ? rowData?.user_update_at : rowData?.manager_update_at;
  
      let formattedDate = "";
      if (timeToShow) {
        const dtSql = DateTime.fromSQL(timeToShow);
        const dt = dtSql.isValid ? dtSql : DateTime.fromISO(timeToShow);
        formattedDate = dt.isValid ? dt.toFormat(dateTimeFmt) : "";
      }
  
      const combined = `${who} ${formattedDate}`;
      return removeDiacritics(combined).toLowerCase().includes(search);
    }

    function IDRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.id)return formatID("CHL-",3,rowData?.id);
        return t('Status.NotCreated');
    } 
    
    function IDRowFilter(headerValue, rowValue, rowData) {
      if (!headerValue) return true;

      const search = removeDiacritics(String(headerValue).toLowerCase());

      const displayed = rowData?.id
        ? formatID("CHL-", 3, rowData.id)
        : t('Status.NotCreated');
      return removeDiacritics(displayed.toLowerCase()).includes(search);
    }

    const EMPTY_OPTION = { label: t('Common.EmptyParen'), value: "__empty__" };
    const processStatusOptions = useMemo(() => [
      EMPTY_OPTION,
      { label: t('Status.Created'), value: "Vytvorený" },
      { label: t('Status.InProgressWork'), value: "Rozpracovaný" },
      { label: t('Status.NotCreated'), value: "Nevytvorený" },
    ], []);
    const managerStatusOptions = useMemo(() => [
      EMPTY_OPTION,
      { label: t('Common.New'), value: "Nový" },
      { label: t('Common.Yes'), value: "Áno" },
      { label: t('Common.No'), value: "Nie" },
    ], []);

    const norm = (v) => removeDiacritics(String(v ?? "")).toLowerCase().trim();

    function getManagerDeadlineInfo(rowData) {
        const baseDate = parseDT(rowData?.user_update_at) || parseDT(rowData?.created_at);
        const dueDays = Number(rowData?.template?.manager_due_days ?? 0);
        if (!baseDate) return { deadline: null, isRed: false };

        const deadline = baseDate.plus({ days: dueDays }).endOf("day");
        const now = DateTime.now().setZone(timezone);

        const expressedAt = parseDT(rowData?.manager_update_at);

        const isLateExpression = !!(expressedAt && expressedAt > deadline);
        const isExpiredAndNotExpressed = !expressedAt && now > deadline;

        const isRed = (isLateExpression || isExpiredAndNotExpressed) && rowData?.status !== "OK";
        return { deadline, isRed };
    }

    const parseDT = (value) => {
        if (!value) return null;
        let dt = DateTime.fromISO(value);
        if (dt.isValid) return dt;
        dt = DateTime.fromSQL(value);
        if (dt.isValid) return dt;
        return null;
    };

    function DeadlineFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const baseDate = parseDT(rowData?.user_update_at) || parseDT(rowData?.created_at);
        if (!baseDate) return <div className="flex items-center justify-start w-full h-full"></div>;
        const { deadline, isRed } = getManagerDeadlineInfo(rowData);
        const managerName =
        rowData?.manager?.employee?.name ||
        rowData?.manager?.username ||
        rowData?.template?.manager?.employee?.name ||
        rowData?.template?.manager?.username ||
        "";
        const managerUsername =
        rowData?.manager?.username ||
        rowData?.template?.manager?.username ||
        "";

        return (
        <div className="flex items-center justify-start w-full h-full">
            {(rowData?.manager || rowData?.template?.manager) && (
            <div className="mr-2">
                <Avatar
                title={managerName}
                label={getUserInitials(managerName)}
                shape="circle"
                style={{
                    backgroundColor: getUserColor(managerUsername),
                    color: "#ffffff",
                    marginRight: "5px",
                }}
                />
            </div>
            )}
            <div className={isRed ? "text-red-600 font-semibold" : ""}>
            {deadline.toFormat(dateFmt)}
            </div>
        </div>
        );
    }

    function deadlineFilter(headerValue, rowValue, rowData) {
        const q = norm(headerValue);
        if (!q) return true;

        const { deadline, isRed } = getManagerDeadlineInfo(rowData);
        if (!deadline) return false;

        if (q === "nok" || q === "!" || q.includes("cerv") || q.includes("red") || q.includes("po termine") || q.includes("omesk") || q.includes("overdue") || q.includes("late")) {
        return isRed;
        }
        if (q === "ok" || q.includes("zel") || q.includes("green") || q.includes("v poriadku") || q.includes("bez cerv")) {
        return !isRed;
        }

        const formattedDeadline = deadline.toFormat(dateFmt);
        const isoDeadline = deadline.toFormat("yyyy-MM-dd");
        const shortDeadline = deadline.toFormat("dd.MM.");

        const managerName =
        rowData?.manager?.employee?.name ||
        rowData?.manager?.username ||
        rowData?.template?.manager?.employee?.name ||
        rowData?.template?.manager?.username ||
        "";

        const combined = `${formattedDeadline} ${isoDeadline} ${shortDeadline} ${managerName}`;
        return norm(combined).includes(q);
    }

    function DateFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const c = DateTime.fromISO(rowData?.created_at);
        const u = DateTime.fromISO(rowData?.updated_at);
        const sameInstant = c.isValid && u.isValid && Math.abs(u.toMillis() - c.toMillis()) <= 1000; // 1s
        const dateStr = (typeof formatDate === 'function' ? formatDate(rowData?.updated_at, true) : null) ?? (rowData?.updated_at ? String(rowData.updated_at) : '');
        if(rowData?.process_status== 'Nevytvorený' && sameInstant){
          return <div className='flex items-center justify-start w-full h-full'>
            <Avatar className='p-overlay-badge' title="System" icon="pi pi-database" shape="circle" style={{ backgroundColor: 'grey', color: '#ffffff',marginRight: '5px'}}/>
            <div>{dateStr}</div>
        </div>;
        }
        return <div className='flex items-center justify-start w-full h-full'>
            {rowData?.last_touched_by_user && <div><Avatar title={rowData?.last_touched_by_user?.employee?.name || rowData?.last_touched_by_user?.username} label={getUserInitials(rowData?.last_touched_by_user?.employee?.name || rowData?.last_touched_by_user?.username)} shape="circle" style={{ backgroundColor: getUserColor(rowData?.last_touched_by_user?.username), color: '#ffffff',marginRight: '5px'}} /></div>}
            <div>{dateStr}</div>
        </div>;
    }

    function dateOrUserFilter(headerValue, rowValue, rowData, filterParams) {
        if (!headerValue) return true; // prázdny filter = všetko
        const normalize = (str) =>
            (str || "")
                .toString()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase();

        const search = normalize(headerValue);
        // Posledná aktivita (DateFormatter)
        if (filterParams?.name=="updated_at" && rowData?.last_touched_by_user) {
            const touchedName = rowData.last_touched_by_user?.employee?.name || rowData.last_touched_by_user?.username;
            if (normalize(touchedName).includes(search)) {
                return true;
            }
        }

        if (filterParams?.name === "updated_at") {
          const dt = DateTime.fromISO(rowData?.updated_at);
          if (dt.isValid) {
            const variants = [
              dt.toFormat(dateFmt),
              dt.toFormat(dateTimeFmt),
              dt.toFormat("HH:mm"),
              dt.toFormat("yyyy-MM-dd"),
            ].join(" ");
            if (normalize(variants).includes(search)) return true;
          }
        }


        // Vykonanie/Deadline (AwaitingUserFormatter)
        if (filterParams?.name === "waiting_for_action_by" && rowData?.deadline) {
            const dt = DateTime.fromISO(rowData.deadline);
            if (dt.isValid && dt.toFormat(dateFmt).includes(headerValue)) return true;
        }

        if (filterParams?.name=="waiting_for_action_by" && rowData?.awaiting_user?.length) {
            for (const u of rowData.awaiting_user) {
                const uname = u?.employee?.name || u?.username;
                if (normalize(uname).includes(search)) return true;
            }
        }

        // Zalozenie
        if (filterParams?.name=="created_at" && rowData?.contractor) {
            const touchedName = rowData.contractor?.employee?.name || rowData.contractor?.username;
            if (normalize(touchedName).includes(search)) {
                return true;
            }
        }

        if (filterParams?.name === "created_at" && rowData?.created_at != null) {
            const dt = DateTime.fromISO(rowData.created_at);
            if (dt.isValid && dt.toFormat(dateFmt).includes(headerValue)) return true;
        }

        return false;
    }

    function UserUpdateFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.process_status== 'Nevytvorený' || rowData?.process_status== 'Rozpracovaný')return null;
        const userName = rowData?.user?.employee?.name || rowData?.user?.username;
        const baseAvatar = (
          <Avatar
            title={userName}
            label={getUserInitials(userName)}
            shape="circle"
            style={{ backgroundColor: getUserColor(rowData?.user?.username), color: '#ffffff', marginRight: '5px' }}
          />
        );
        const isSubstitute = rowData?.is_substitute;

        return <div className='flex items-center justify-start w-full h-full'>
            {rowData?.user && (
              <div>
                {isSubstitute ? (
                  <span style={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}>{baseAvatar}<span className="p-badge p-badge-info" style={{ position: 'absolute', top: '-2px', right: '-2px', fontSize: '0.75rem', minWidth: '14px', height: '14px', lineHeight: '14px', padding: '0 3px' }}>Z</span></span>
                ) : baseAvatar}
              </div>
            )}
            <div>{(typeof formatDate === 'function' ? formatDate(rowData?.user_update_at, true) : null) ?? (rowData?.user_update_at ? String(rowData.user_update_at) : '')}</div>
        </div>;
    }
    function userUpdateFilter(headerValue, rowValue, rowData, filterParams) {
        if (!headerValue) return true; // prázdny filter = všetko
        if (rowData?.process_status === "Nevytvorený" || rowData?.process_status== 'Rozpracovaný') return false;
        const normalize = (str) =>
            (str || "")
                .toString()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase();
        const search = normalize(headerValue);
        if (filterParams?.name=="user_update_at" && rowData?.user) {
            const touchedName = rowData.user?.employee?.name || rowData.user?.username;
            if (normalize(touchedName).includes(search)) {
                return true;
            }
        }
        if (filterParams?.name === "user_update_at" && rowData?.user_update_at) {
            const dt = DateTime.fromSQL(rowData.user_update_at);
            if (dt.isValid && dt.toFormat(dateTimeFmt).includes(headerValue)) return true;
        }
        return false;
    }

    const markAsViewed = async (recordId, value, cell) => {
      const formData = new FormData();
      formData.append("record_id", recordId);
      formData.append("user_id", user.id);
      const url = !value
        ? `/api/checklist_records/${recordId}/mark-as-viewed`
        : `/api/checklist_records/${recordId}/mark-as-not-viewed`;
      try {
        await postRequest(url, formData, true);
        if (cell) cell.getRow().update({ is_unread: value });
      } catch (err) {}
    };

      
    function MailIconTemplate(props) {
      const rowData = props.cell.getRow().getData();
      const commentsCount = rowData.comments_count ?? (rowData.comments?.length ?? 0);
      if ((rowData?.manager_response?.length ?? 0) > 0 || commentsCount > 0) {
        const isUnread = rowData?.is_unread;

        return (
          <div className="flex items-center gap-2">
            {isUnread ? (
              <button type="button" title={t('Common.MarkAsRead')} onClick={() => markAsViewed(rowData.id, false, props.cell)} className="hover:opacity-75">
                <UnseenIcon />
              </button>
            ) : (
              <button type="button" title={t('Common.MarkAsUnread')} onClick={() => markAsViewed(rowData.id, true, props.cell)} className="hover:opacity-75">
                <SeenIcon />
              </button>
            )}
          </div>
        );
      }
      return "";
    }

    const machineOptions = useMemo(() => [
      { label: t('Common.EmptyParen'), value: "__empty__" },
      ...(state.machines || []).map(m => ({ label: m.name, value: m.name })).sort((a, b) => (a.label || "").localeCompare(b.label || "", "sk")),
    ], [state.machines]);
    const departmentOptions = useMemo(() => [
      { label: t('Common.EmptyParen'), value: "__empty__" },
      ...(state.departments || [])
        .filter(d => d?.id != null && d?.id !== "")
        .map(d => ({ label: d.name, value: String(d.id) }))
        .sort((a, b) => (a.label || "").localeCompare(b.label || "", "sk")),
    ], [state.departments]);

    const columns = useMemo(() => [
      { formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center", width: 44, headerSort: false, resizable: false },
      { hozAlign:"center", width: 44, headerSort: false, formatter: reactFormatter(<EditRowFormatter/>), resizable: false },
      { title: t('Common.Name'), field: "template.name", headerFilter: "input", headerFilterFunc: genericFilter, minWidth: 200},
      { title: t('Common.Machine'), field: "template.machine.name", minWidth: 220,
        headerFilter: primeMultiSelectHeaderFilter,
        headerFilterParams: { placeholder: t('Common.FilterAll'), valueType: "string", options: machineOptions },
        headerFilterFunc: (headerValue, rowValue, rowData) => {
          if (!headerValue) return true;
          const selected = new Set(String(headerValue).split(",").map(x => x.trim()).filter(Boolean));
          const machineName = rowData?.template?.machine?.name ?? rowData?.["template.machine.name"] ?? "";
          const isEmpty = machineName === "" || machineName == null;
          if (selected.has("__empty__") && isEmpty) return true;
          return selected.has(machineName);
        }
      },
      { title: t('MachineTypeList.Column.Id'), field: 'id', formatter: reactFormatter(<IDRowFormatter/>), headerFilter:"input", headerFilterFunc: IDRowFilter, minWidth: 100, widthGrow:1},
      { title: t('Common.Read'), field: 'is_unread', minWidth: 100, formatter: reactFormatter(<MailIconTemplate/>), headerFilter: 'list', headerFilterParams: { values: { '': t('Common.FilterAll'), 'true': t('Common.Unread'), 'false': t('Common.Read') } } },
      { title: t('Common.Description'), field: "name", headerFilter: "input", headerFilterFunc: genericFilter, minWidth: 190},
      { title: t('Common.Department'), field: "custom_department", minWidth: 220, formatter: reactFormatter(<DepartmentFormatter />),
        headerFilter: primeMultiSelectHeaderFilter,
        headerFilterParams: { placeholder: t('Common.FilterAll'), valueType: "string", options: departmentOptions },
        headerFilterFunc: (headerValue, rowValue, rowData, filterParams) => {
          if (!headerValue) return true;
          const selected = new Set(String(headerValue).split(",").map(x => x.trim()).filter(Boolean));
          const deptId = rowData?.user?.employee?.department_id ?? rowData?.user?.employee?.department?.id;
          const isEmpty = deptId == null || deptId === "";
          if (selected.has("__empty__") && isEmpty) return true;
          if (!deptId) return false;
          return selected.has(String(deptId));
        }
      },
      { title: t('Common.Column.CreatedAt'), field: "created_at", headerFilter: "input", headerFilterFunc: userFilter, minWidth: 190, formatter: reactFormatter(<UserFormatter />)},
      { title: t('Checklist.Column.CompletionDate'),field: "user_update_at",minWidth: 230,formatter: reactFormatter(<UserUpdateFormatter />),headerFilter: "input",headerFilterFunc: userUpdateFilter,},
      { title: t('Checklist.Column.CompletionDeadline'),field: "execution_deadline",minWidth: 230,formatter: reactFormatter(<ExecutionDeadlineFormatter timezone={timezone} />),headerFilter: "input",headerFilterFunc: executionDeadlineFilter,headerFilterFuncParams: { getDateFormat: () => getDateFormat?.() ?? "dd.MM.yyyy", timezone },},
      { title: t('Common.Column.UpdatedAt'), field: 'updated_at', minWidth: 200, widthGrow: 1, formatter: reactFormatter(<DateFormatter/>), headerFilter: "input", headerFilterFunc: dateOrUserFilter, headerFilterFuncParams: { name: "updated_at" } },
      { title: t('Common.Status'), field: "status", minWidth: 180,
        headerFilter: primeMultiSelectHeaderFilter,
        headerFilterParams: { placeholder: t('Common.FilterAll'), valueType: "string", options: [EMPTY_OPTION, { label: "OK", value: "OK" }, { label: "NOK", value: "NOK" }] },
        headerFilterFunc: (headerValue, rowValue) => {
          if (!headerValue) return true;
          const selected = new Set(String(headerValue).split(",").map(x => x.trim()).filter(Boolean));
          const isEmpty = rowValue == null || String(rowValue).trim() === "";
          if (selected.has("__empty__") && isEmpty) return true;
          return selected.has(String(rowValue));
        }
      },
      { title: t('Checklist.Column.ProcessStatus'), field: "process_status", minWidth: 200,
        headerFilter: primeMultiSelectHeaderFilter,
        headerFilterParams: { placeholder: t('Common.FilterAll'), valueType: "string", options: processStatusOptions },
        headerFilterFunc: (headerValue, rowValue) => {
          if (!headerValue) return true;
          const selected = new Set(String(headerValue).split(",").map(x => x.trim()).filter(Boolean));
          const isEmpty = rowValue == null || String(rowValue).trim() === "";
          if (selected.has("__empty__") && isEmpty) return true;
          return selected.has(String(rowValue));
        }
      },
      { title: t('Checklist.Column.ResponseDate'), field: "manager_name", minWidth: 200, formatter: reactFormatter(<ManagerFormatter />), headerFilter: "input", headerFilterFunc: managerHeaderFilter},
      { title: t('ChecklistRecordList.Column.StatementDeadline'), field: "deadline", minWidth: 210, formatter: reactFormatter(<DeadlineFormatter />),headerFilter: "input",headerFilterFunc: deadlineFilter,},
      { title: t('MaintenanceCheckStateList.Column.Statement'), field: "manager_response", headerFilter: "input", headerFilterFunc: genericFilter, minWidth: 200, widthGrow:1},
      { title: t('Checklist.Column.ResponseStatus'), field: "manager_status", minWidth: 200, widthGrow: 1,
        headerFilter: primeMultiSelectHeaderFilter,
        headerFilterParams: { placeholder: t('Common.FilterAll'), valueType: "string", options: managerStatusOptions },
        headerFilterFunc: (headerValue, rowValue) => {
          if (!headerValue) return true;
          const selected = new Set(String(headerValue).split(",").map(x => x.trim()).filter(Boolean));
          const isEmpty = rowValue == null || String(rowValue).trim() === "";
          if (selected.has("__empty__") && isEmpty) return true;
          return selected.has(String(rowValue));
        }
      },
      { title: t('Checklist.Column.ChecklistStatus'), field: "checklist_status", minWidth: 200,
        headerFilter: primeMultiSelectHeaderFilter,
        headerFilterParams: { placeholder: t('Common.FilterAll'), valueType: "string", options: [EMPTY_OPTION, { label: t('Status.Open'), value: "Otvorený" }, { label: t('Status.Closed'), value: "Uzavretý" }] },
        headerFilterFunc: (headerValue, rowValue) => {
          if (!headerValue) return true;
          const selected = new Set(String(headerValue).split(",").map(x => x.trim()).filter(Boolean));
          const isEmpty = rowValue == null || String(rowValue).trim() === "";
          if (selected.has("__empty__") && isEmpty) return true;
          return selected.has(String(rowValue));
        }
      },
    ], [machineOptions, departmentOptions, processStatusOptions, managerStatusOptions]);

  useEffect(() => {
    getTable()?.setColumns?.(columns);
  }, [columns]);
  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: CHECKLIST_RECORD_MY_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);


function editChecklistRecord(){
  const table = getTable();
  const sel = (table?.getSelectedData?.() ?? [])[0];
  const filters = (table?.getHeaderFilters?.() || []).map(f => ({ field: f.field, value: f.value }));
  const sorters = cleanSorters(table?.getSorters?.() || []);
  const { from, to } = getMyListDateRange(timePeriodRef.current, dateRef.current);
  const navigationContext = { filters, sorters, preview: previewRef.current, preview_time_from: from || undefined, preview_time_to: to || undefined };
  dispatch({type: 'create_new_tab', name: t('Checklist.RecordTab'), translationKey: 'Checklist.RecordTab', legacyLabel: t('Checklist.RecordTab'),page:'ChecklistRecordMyDetail',props:{checklist_record: sel,recordId: sel?.id,type:'edit',navigationContext},mask:'chck006'})
}

function openSubstituteDialog() {
  if (!canCreate) return;
  getRequest('/api/checklist_records/substitute-templates').then((response) => {
    const list = response?.data?.data ?? [];
    if (list.length === 0) {
      toast?.current?.show({ severity: 'info', summary: t('Checklist.NoSubstitution'), detail: t('Checklist.NoSubstitutionToday'), life: 4000 });
      return;
    }
    setSubstituteOptions(list);
    setSubstituteDialogVisible(true);
  }).catch(() => {
    toast?.current?.show({ severity: 'error', summary: t('Common.Error'), detail: t('Common.ListLoadFailed'), life: 3000 });
  });
}

function chooseSubstituteOption(item) {
  if (!canCreate) return;
  setSubstituteDialogVisible(false);
  setSubstituteOptions([]);
  dispatch({
    type: 'create_new_tab', name: t('Checklist.NewRecordAsSubstitute'), translationKey: 'Checklist.NewRecordAsSubstitute', legacyLabel: t('Checklist.NewRecordAsSubstitute'),
    page: 'ChecklistRecordAdd',
    props: { checklist_template: item.template, type: 'add', original_user_id: item.original_user_id },
    mask: 'chck004',
  });
}

const scrollToFirst = () => scrollToFirstUtil(getTable());
  const scrollUp = () => scrollUpUtil(getTable());
  const scrollDown = () => scrollDownUtil(getTable());
  const scrollToLast = () => scrollToLastUtil(getTable());

 const itemRenderer = (item, options) => (
    <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
        <span className={`${item.icon} text-primary`} />
        <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
        {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
    </a>
  );

  const [expandedKeys, setExpandedKeys] = useState({});

  const handleClickOutside = (event) => {
    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setExpandedKeys({});
    }
  };

  useEffect(() => {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
          document.removeEventListener('click', handleClickOutside, true);
      };
  }, []);

    const items = [
    {
      key: '0',
      label: t('Common.Actions'),
      icon: 'pi pi-sliders-v',
      template: itemRenderer,
      items: [
            {
              key: '0_1',
              label: t('Common.SetFilter'),
              icon: 'pi pi-filter',
              command: () => {setUserMaskFilter("ChecklistRecordMyList","set_filters",null,getTable()?.getHeaderFilters?.() ?? [],null);},
              template: itemRenderer,
          },
            {
              key: '0_2',
              label: t('Common.ClearFilter'),
              icon: 'pi pi-filter-slash',
              command: () => {getTable()?.clearHeaderFilter?.(); setUserMaskFilter("ChecklistRecordMyList","set_filters",null,[],null);},
              template: itemRenderer,
          },
          {
              key: '0_3',
              label: t('ServiceTask.SetSort'),
              icon: 'pi pi-sort-alt',
              command: () => {setUserMaskFilter("ChecklistRecordMyList","set_sorters",null,null,null,cleanSorters(getTable()?.getSorters?.() ?? []));OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
              template: itemRenderer,
          },
          {
              key: '0_4',
              label: t('Common.ClearSorting'),
              icon: 'pi pi-sort-alt-slash',
              command: () => {setUserMaskFilter("ChecklistRecordMyList","set_sorters",null,null,null,[]);getTable()?.setSort?.([]);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
              template: itemRenderer,
          },
          {
              key: '0_5',
              label: t('Common.SetMask'),
              icon: 'pi pi-server',
              command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
              template: itemRenderer,
          },
          {
              key: '0_5b',
              label: t('Common.ResetUserMask'),
              icon: 'pi pi-refresh',
              command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
              template: itemRenderer,
          },
          {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('ChecklistRecordMyList');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
      ]
    }
  ];

  const resetMask = () => resetTabulatorMask({
    page: 'ChecklistRecordMyList',
    defaultColumnsVisible: DEFAULT_COLUMNS_VISIBLE_MY,
    ref,
    columns,
    setColumnsVisible,
  });function changeMarkings(value){
    const columnVisible = {...columnsVisible};
    for(let val in columnVisible) {
      if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
        columnVisible[val]=value;
        getTable()?.showColumn?.(`${val}`);
      }
    };
    setColumnsVisible(columnVisible);
    setTimeout(() => {
      getTable()?.redraw?.(true);
    }, 0);
  }

  const normalizeMaskValue = (field, value) => {
    if (value === null || value === undefined) return "";
    if (field === "is_unread") return value === "" ? "" : String(value);
    return value;
  };

  const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
    const table = getTable();
    const p = previewRef.current;
    const extra = { ...extractSafePaginationParams(paramsFromTabulator) };

    if (p) {
      const { from, to } = getMyListDateRange(timePeriodRef.current, dateRef.current);
      extra.preview = p;
      if (from) extra.preview_time_from = from;
      if (to) extra.preview_time_to = to;
      if (from) extra.filter_created_at_from = from;
      if (to) extra.filter_created_at_to = to;
      if (p === 'ok') extra.filter_status = 'OK';
      if (p === 'nok') extra.filter_status = 'NOK';
      if (p === 'rozpracovane') extra.filter_process_status = t('Status.InProgressWork');
      return extra;
    }

    const tableReadyForParams = tableBuiltRef.current;
    let hf = [];
    if (tableReadyForParams) {
      hf = table?.getHeaderFilters?.() ?? [];
    }

    if (tableReadyForParams && hf.length) {
      hf.forEach(f => {
        if (f?.field === undefined) return;
        const rawVal = f.value;
        let vStr = (rawVal === undefined || rawVal === null) ? "" : String(rawVal).trim();
        if (f.field === "checklist_status") {
          const parts = vStr.split(",").map(x => x.trim()).filter(Boolean);
          if (parts.length === 0 || parts.length >= 3) vStr = "";
          else vStr = parts.join(",");
        }
        const filterKey = f.field === "template.machine.name" ? "filter_template_machine_name" : `filter_${f.field}`;
        extra[filterKey] = vStr;
      });
      const dateFilterFields = ["created_at", "user_update_at", "updated_at", "manager_name", "deadline", "execution_deadline"];
      const hasDateFilter = hf.some(f => f?.field && dateFilterFields.includes(f.field) && String(f?.value ?? "").trim() !== "");
      if (hasDateFilter) extra.filter_date_format = getDateFormat?.() ?? "dd.MM.yyyy";
    } else if (!tableReadyForParams && useMaskDefaultsRef.current && state.user_mask_filters) {
      const maskRow = state.user_mask_filters.find(m => m.page === "ChecklistRecordMyList");
      if (maskRow) {
        parseMaskFilters(maskRow.filters).forEach(f => {
          if (!f?.field) return;
          const v = f.value;
          if (v === undefined || v === null || String(v).trim() === "") return;
          const filterKey = f.field === "template.machine.name" ? "filter_template_machine_name" : `filter_${f.field}`;
          extra[filterKey] = f.field === "is_unread" ? String(v) : v;
        });
      }
    }

    let sortersFromTable = [];
    if (tableReadyForParams) {
      sortersFromTable = table?.getSorters?.() ?? [];
    }
    const hasSorters = Array.isArray(sortersFromTable) && sortersFromTable.length > 0;
    if (hasSorters) {
      const clean = cleanSorters(sortersFromTable);
      if (clean.length > 0) extra.sorters = JSON.stringify(clean);
    } else if (!tableReadyForParams && useMaskDefaultsRef.current && state.user_mask_filters) {
      const maskRow = state.user_mask_filters.find(m => m.page === "ChecklistRecordMyList");
      if (maskRow?.sorters) {
        const parsed = parseSorters(maskRow.sorters);
        if (parsed.length > 0) extra.sorters = JSON.stringify(parsed);
      }
    }
    return extra;
  }, [getTable, state.user_mask_filters, state.module_settings]);

  const options = useMemo(() => ({
    layout: "fitColumns",
    selectableRows: true,
    dataLoader: true,
    dataLoaderLoading: t('Common.LoadingData'),
    dataLoaderError: t('Common.LoadingFailed'),
    placeholder: t('Common.NoData'),
    height: "calc(100vh - 193px)",
    rowHeight: 42,
    renderHorizontal: "virtual",
    progressiveLoad: "scroll",
    progressiveLoadScrollMargin: 80,
    progressiveLoadDelay: 200,
    paginationSize: pageSizePc,
    progressiveRender: true,
    progressiveRenderSize: 30,
    pagination: false,
    filterMode: "remote",
    sortMode: "remote",
    ajaxURL: "/api/checklist_records/paged",
    ajaxParams: () => ({}),
    ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
    ajaxRequesting: () => {
      loadingRef.current = true;
      captureHScroll();
      const table = getTable();
      if (table?.initialized) table.alert?.(t('Common.LoadingData'));
      return true;
    },
    ajaxResponse: (url, params, response) => {
      loadingRef.current = false;
      getTable()?.clearAlert?.();
      pagingRef.current.current = response?.current_page ?? params?.page ?? pagingRef.current.current;
      pagingRef.current.last = response?.last_page ?? pagingRef.current.last;
      return response;
    },
    ajaxError: () => {
      loadingRef.current = false;
      getTable()?.clearAlert?.();
    },
    printAsHtml: true,
    printHeader: () => buildCanonicalPrintHeaderHtml({
      branding: state?.branding,
      productFallbackSrc: defaultProductLogoSrc,
      companySettingsPrint: state?.company_settings_print,
      moduleSettings: state?.module_settings,
      title: t('Print.Title.ChecklistRecordMyList'),
      printDateLabel: t('Print.DateLabel'),
    }),
    printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
    printRowRange: "active",
    autoResize: true,
    scrollToColumnIfVisible: false,
    movableColumns: true,
  }), []);

  const mergeAttributesWithCurrentOptions = (attrs) => {
    if (!Array.isArray(attrs)) return attrs;
    return attrs.map(a => {
      if (typeof a !== "object" || a == null) return a;
      const copy = { ...a };
      const field = copy.field;
      if (field === "template.machine.name" && Array.isArray(machineOptions) && machineOptions.length > 0) {
        copy.headerFilterParams = { ...(copy.headerFilterParams || {}), options: machineOptions, valueType: "string", placeholder: t('Common.FilterAll') };
      } else if (field === "custom_department" && Array.isArray(departmentOptions) && departmentOptions.length > 0) {
        copy.headerFilterParams = { ...(copy.headerFilterParams || {}), options: departmentOptions, valueType: "string", placeholder: t('Common.FilterAll') };
      } else if (field === "status") {
        copy.headerFilterParams = { ...(copy.headerFilterParams || {}), options: [EMPTY_OPTION, { label: "OK", value: "OK" }, { label: "NOK", value: "NOK" }], valueType: "string", placeholder: t('Common.FilterAll') };
      } else if (field === "process_status" && Array.isArray(processStatusOptions) && processStatusOptions.length > 0) {
        copy.headerFilterParams = { ...(copy.headerFilterParams || {}), options: processStatusOptions, valueType: "string", placeholder: t('Common.FilterAll') };
      } else if (field === "manager_status" && Array.isArray(managerStatusOptions) && managerStatusOptions.length > 0) {
        copy.headerFilterParams = { ...(copy.headerFilterParams || {}), options: managerStatusOptions, valueType: "string", placeholder: t('Common.FilterAll') };
      } else if (field === "checklist_status") {
        copy.headerFilterParams = { ...(copy.headerFilterParams || {}), options: [EMPTY_OPTION, { label: t('Status.Open'), value: "Otvorený" }, { label: t('Status.Closed'), value: "Uzavretý" }], valueType: "string", placeholder: t('Common.FilterAll') };
      }
      return copy;
    });
  };

  const applyMask = (maskRow) => {
    let attributes = safeParse(maskRow.attributes, []);
    attributes = mergeAttributesWithCurrentOptions(attributes);
    const filters = parseMaskFilters(maskRow.filters);
    const sorters = parseSorters(maskRow.sorters);
    const json_columns = safeParse(maskRow.columns, {});
    const table = getTable();
    isRestoringRef.current = true;
    if (Array.isArray(attributes) && attributes.length > 1) {
      table?.setColumnLayout?.(attributes);
    }
    if (json_columns && typeof json_columns === "object") {
      setColumnsVisible(json_columns);
      for (const colField in json_columns) {
        json_columns[colField] === false ? table?.hideColumn?.(colField) : table?.showColumn?.(colField);
      }
    }
    const applyFiltersAndSorters = () => {
      if (maskAppliedRef.current) return;
      maskAppliedRef.current = true;
      if (Array.isArray(sorters) && sorters.length > 0) table?.setSort?.(sorters);
      if (Array.isArray(filters) && filters.length > 0) {
        setTimeout(() => {
          filters.forEach(f => {
            if (!f?.field) return;
            table?.setHeaderFilterValue?.(f.field, normalizeMaskValue(f.field, f.value), true);
          });
        }, 0);
      } else {
        table?.clearHeaderFilter?.();
      }
    };
    if (table?.getDataCount?.() > 0) {
      applyFiltersAndSorters();
    } else {
      maskToApplyRef.current = { applyFiltersAndSorters };
    }
  };

  useEffect(() => {
    if (!tableReady || !getTable() || preview) return;
    const maskRow = state.user_mask_filters?.find(m => m.page === "ChecklistRecordMyList");
    if (!maskRow) return;
    const sig = JSON.stringify([maskRow.attributes, maskRow.columns, maskRow.filters, maskRow.sorters]);
    if (sig === lastMaskSigRef.current) return;
    lastMaskSigRef.current = sig;
    maskAppliedRef.current = false;
    maskToApplyRef.current = null;
    applyMask(maskRow);
  }, [tableReady, state.user_mask_filters, preview]);

  function setMask(item,value){
    const columnVisible = {...columnsVisible};
   columnVisible[item] = value;
    for(const val in columnVisible) {
      if(columnVisible[val]==false){
        getTable()?.hideColumn?.(`${val}`);
      }
      else{
        getTable()?.showColumn?.(`${val}`);
      }
    }
    setColumnsVisible(columnVisible);
    setTimeout(() => {
      getTable()?.redraw?.(true);
    }, 0)
  }

  useEffect(() => {
    if (state.selectedTab != null && isTableVisible() && needsRedrawRef.current) scheduleRedraw();
  }, [state.selectedTab, isTableVisible, scheduleRedraw]);

  // ResizeObserver: keď sa záložka znova zobrazí (návrat z detailu), prekresli tabuľku – oprava neúplného náhľadu (rovnako ako intr003)
  const lastContainerHeightRef = useRef(0);
  useEffect(() => {
    const el = tableContainerRef.current;
    if (!el) return;
    const ro = new ResizeObserver(() => {
      const h = el.clientHeight;
      if (h > 0) {
        const wasHidden = lastContainerHeightRef.current <= 0;
        lastContainerHeightRef.current = h;
        if (wasHidden) requestAnimationFrame(() => getTable()?.redraw?.(true));
        else if (el.offsetParent != null && needsRedrawRef.current) scheduleRedraw();
      } else {
        lastContainerHeightRef.current = 0;
      }
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [scheduleRedraw, getTable]);

  useEffect(() => {
    const handler = (e) => {
      const updated = e.detail;
      if (!updated?.id) return;
      const table = getTable();
      if (!table?.getRow) return;
      const row = table.getRow(updated.id);
      if (row) {
        row.update(updated).then(() => {
          pendingRowIdsRef.current.add(updated.id);
          if (isTableVisible()) scheduleRedraw();
          else needsRedrawRef.current = true;
        }).catch(() => {});
      } else {
        table.addData?.([updated]);
        pendingRowIdsRef.current.add(updated.id);
        if (isTableVisible()) scheduleRedraw();
        else needsRedrawRef.current = true;
      }
    };
    window.addEventListener("checklist_my_records:updated", handler);
    return () => window.removeEventListener("checklist_my_records:updated", handler);
  }, [getTable, isTableVisible, scheduleRedraw]);

  // Označenie prečítané v detaile → aktualizuj riadok v tabuľke.
  // Dáta zoznamu sú z progressive loading (ajaxURL), nie zo state. lastRecordViewedUpdate je len signál;
  // nájdeme riadok v už načítanej tabuľke a aktualizujeme ho v mieste (row.update), alebo replaceData().
  useEffect(() => {
    const u = state.lastRecordViewedUpdate;
    if (!u) return;
    const table = getTable();
    if (!table?.getRow) return;
    const row = table.getRow(u.recordId);
    if (row) {
      const data = row.getData?.();
      if (data) row.update({ ...data, is_unread: u.value }).catch(() => {});
    } else {
      refreshFromStart();
    }
  }, [state.lastRecordViewedUpdate, getTable]);

  useEffect(() => {
    const channel = getPusherChannel();
    if (!channel) return;
    const getId = (data) => data?.id ?? data?.record?.id ?? null;
    const isMine = (record) => (record?.user_id ?? record?.user?.id) == user?.id;
    const DEDUPE_MS = 800;
    const lastHandled = { key: '', at: 0 };
    const shouldSkip = (eventType, id) => {
      if (id == null) return true;
      const key = `${eventType}-${id}`;
      const now = Date.now();
      if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
      lastHandled.key = key;
      lastHandled.at = now;
      return false;
    };

    const onUpdated = (data) => {
      const id = getId(data);
      if (id == null || shouldSkip('updated', id)) return;
      getRequest(`/api/checklist_records/${id}`)
        .then((res) => {
          const record = res?.data ?? res;
          if (!record?.id) return;
          const table = getTable();
          if (!table?.getRow) return;
          if (record?.validity === 0) {
            const row = table.getRows?.().find((r) => r.getData().id === record.id);
            if (row) row.delete();
            return;
          }
          if (!isMine(record)) return;
          const rc = table.getRow(record.id);
          if (rc) {
            rc.update(record).then(() => {
              pendingRowIdsRef.current.add(record.id);
              if (isTableVisible()) scheduleRedraw();
              else needsRedrawRef.current = true;
            }).catch(() => {});
          } else {
            table.addData?.([record]);
            pendingRowIdsRef.current.add(record.id);
            if (isTableVisible()) scheduleRedraw();
            else needsRedrawRef.current = true;
          }
        })
        .catch(() => {});
    };
    const onCreated = (data) => {
      const id = getId(data);
      if (id == null || shouldSkip('created', id)) return;
      getRequest(`/api/checklist_records/${id}`)
        .then((res) => {
          const record = res?.data ?? res;
          if (!record?.id || record?.validity === 0 || !isMine(record)) return;
          const table = getTable();
          if (!table?.addData) return;
          table.addData([record]);
          pendingRowIdsRef.current.add(record.id);
          if (isTableVisible()) scheduleRedraw();
          else needsRedrawRef.current = true;
        })
        .catch(() => {});
    };
    const onDeleted = (data) => {
      const id = getId(data);
      if (id == null || shouldSkip('deleted', id)) return;
      const table = getTable();
      const row = table?.getRows?.().find((r) => r.getData().id === id);
      if (row) row.delete();
    };
    channel.bind('checklist_record.created', onCreated);
    channel.bind('checklist_record.updated', onUpdated);
    channel.bind('checklist_record.deleted', onDeleted);
    return () => {
      channel.unbind('checklist_record.created', onCreated);
      channel.unbind('checklist_record.updated', onUpdated);
      channel.unbind('checklist_record.deleted', onDeleted);
    };
  }, [user?.id, getTable, isTableVisible, scheduleRedraw]);

  // Označenie prečítané v detaile → aktualizuj riadok v tabuľke.
  // Dáta zoznamu sú z progressive loading (ajaxURL), nie zo state. lastRecordViewedUpdate je len signál;
  // nájdeme riadok v už načítanej tabuľke a aktualizujeme ho v mieste (row.update), alebo replaceData().
  useEffect(() => {
    const u = state.lastRecordViewedUpdate;
    if (!u) return;
    const table = getTable();
    if (!table?.getRow) return;
    const row = table.getRow(u.recordId);
    if (row) {
      const data = row.getData?.();
      if (data) row.update({ ...data, is_unread: u.value }).catch(() => {});
    } else {
      refreshFromStart();
    }
  }, [state.lastRecordViewedUpdate, getTable]);

    return(
        <>
    <div className='w-full h-10 flex flex-row bg-[#333]'>
      <IntersectionObserverWrapper>
        {canCreate ? (
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="add_substitute" title={t('Common.Search')}><button onClick={openSubstituteDialog}><AddIcon/></button></div>
        ) : null}
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editChecklistRecord()}><EditIcon/></button></div>
        {/*<div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyDepartment()}><CopyIcon/></button></div>*/}
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="print"><button onClick={() => getTable()?.print?.(false, true)}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="search"><button onClick={() => setVisibleSearch(true)}><SearchIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="export"><button onClick={() => getTable()?.download?.("xlsx", "data.xlsx", {sheetName:"MyData"})}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="refresh"><button onClick={() => refreshFromStart()}><RefreshIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('Checklist.List'),"ChecklistRecordMyList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="price"><button onClick={() => setFastView("ChecklistRecordMyList")}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="vert"><VerticalLineIcon/></div>
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
          <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
        </div>
        </IntersectionObserverWrapper>
      </div>
<div className="flex flex-col overflow-hidden min-h-[calc(100vh-177px)]">
  <div className="">
    <div className="inline-block w-full py-2">
    <div ref={elementRef} className="relative">
      <div ref={tableContainerRef}>
      <ReactTabulator
      className='h-[calc(100vh_-_209px)]'
      onRef={(r) => (ref.current = r?.current ?? r)}
      columns={columns}
      events={{
        rowClick: rowClick,
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
          tableBuiltRef.current = true;
          setTableReady(true);
        },
        dataProcessed: () => {
          useMaskDefaultsRef.current = false;
          isRestoringRef.current = false;
          const pending = maskToApplyRef.current;
          if (pending?.applyFiltersAndSorters) {
            pending.applyFiltersAndSorters();
            maskToApplyRef.current = null;
          }
          const t = getTable();
          if (t?.redraw) {
            requestAnimationFrame(() => { t?.redraw?.(true); });
          }
        },
        headerFilterChanged: () => {
          if (!isRestoringRef.current) userInteractedRef.current = true;
          refreshFromStart();
        },
        sortChanged: () => {
          if (!isRestoringRef.current) userInteractedRef.current = true;
        },
        renderComplete: () => {
          restoreHScroll();
        },
        dataSorted: () => {
          if (!isRestoringRef.current) userInteractedRef.current = true;
        },
        columnMoved:() => {
          setUserMaskFilter("ChecklistRecordMyList","column_move",null,null,getTable()?.getColumnLayout?.());
        },
        columnResized: () => {
          setUserMaskFilter("ChecklistRecordMyList", "column_resized", null, null, getTable()?.getColumnLayout?.());
        }
      }}
      options={options}/>
      </div>
    </div> 
      </div>
    </div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Checklist.CreateAsSubstitute')} visible={substituteDialogVisible} style={{ width: '480px' }} onHide={() => { setSubstituteDialogVisible(false); setSubstituteOptions([]); }}>
            <p className="mb-2 text-sm text-surface-600">{t('Ui.R67.Vyberte_sablonu_za_ktoru_chcete_vytvorit_zaznam_dnes_ste_nah')}</p>
            <ul className="list-none p-0 m-0">
              {substituteOptions.map((item, idx) => (
                <li key={idx} className="p-2 border-b border-surface-200 cursor-pointer hover:bg-surface-100 rounded" onClick={() => chooseSubstituteOption(item)}>
                  <span className="font-medium">Za {item.original_user_name}</span>: {item.template?.name ?? ''}
                </li>
              ))}
            </ul>
          </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
                  <div className="flex flex-col">
                  <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
                  {columns.map(function(item, index){ 
                    if(index<2) return null;
                              return <div 
                                  key={index} 
                                  className="flex flex-row border border-black rounded-md p-2 m-1"
                              > 
          
                                   <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                                    
                                  {/* Use the React icon component */} 
                              </div> 
                          })} 
                      <button onClick={() => {setUserMaskFilter("ChecklistRecordMyList","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
                  </div>
                </Dialog>
                
  </div>
 </>
    )

}